import { Link } from "react-router-dom";

import styles from "../HomePage.module.css";

const Category = () => {
  return (
    <div className="bg-[#F8FDFF] w-full px-10 py-8 lg:py-12 lg:py-12 flex justify-center items-center">
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-8 lg:gap-12">
        <Link to="/products/iPhone" className={styles["category-item-card"]}>
          <img
            src={
              "https://res.cloudinary.com/dyxwbtohw/image/upload/v1759252495/iPhone_twacd2.webp"
            }
            alt="ImageiPhone"
            className="w-16 h-16"
          />
          <span className={styles["category-item-card-title"]}>iPhone</span>
        </Link>
        <Link to="/products/iPad" className={styles["category-item-card"]}>
          <img
            src={
              "https://res.cloudinary.com/dyxwbtohw/image/upload/v1759252485/iPad_aa1bji.png"
            }
            alt="ImageiPad"
            className="w-16 h-16"
          />
          <span className={styles["category-item-card-title"]}>iPad</span>
        </Link>
        <Link to="/products/watch" className={styles["category-item-card"]}>
          <img
            src={
              "https://res.cloudinary.com/dyxwbtohw/image/upload/v1759252496/watch_nlm1mz.png"
            }
            alt="ImageWatch"
            className="w-16 h-16"
          />
          <span className={styles["category-item-card-title"]}>Watch</span>
        </Link>

        <Link to="/products/airpods" className={styles["category-item-card"]}>
          <img
            src={
              "https://res.cloudinary.com/dyxwbtohw/image/upload/v1759252485/air-pods_xpiqzy.png"
            }
            alt="ImageAirPods"
            className="w-16 h-16"
          />
          <span className={styles["category-item-card-title"]}>AirPods</span>
        </Link>
        <Link to="/products/airtag" className={styles["category-item-card"]}>
          <img
            src={
              "https://res.cloudinary.com/dyxwbtohw/image/upload/v1759252484/airtag_g9lwon.png"
            }
            alt="ImageAirTag"
            className="w-16 h-16"
          />
          <span className={styles["category-item-card-title"]}>AirTag</span>
        </Link>
        <Link
          to="/products/accessories"
          className={styles["category-item-card"]}
        >
          <img
            src={
              "https://res.cloudinary.com/dyxwbtohw/image/upload/v1759252484/charger_s5t8hg.webp"
            }
            alt="ImageAccessories"
            className="w-16 h-16"
          />
          <span className={styles["category-item-card-title"]}>Phụ kiện</span>
        </Link>
      </div>
    </div>
  );
};
export default Category;
